var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.362,
    height: 32,
    viewBox: "0 0 39.362 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ae236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8acd2e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "truck",
    d: "M5376.987,7008.67v-2.221h2.682v2.221Zm-5.367,0v-2.221h2.684v2.221Zm-5.365,0v-2.221h2.682v2.221Zm-5.367,0v-2.221h2.684v2.221Zm-5.365,0v-2.221h2.682v2.221Zm-5.367,0v-2.221h2.684v2.221Zm-5.365,0v-2.221h2.682v2.221Zm-1.343-4.444V7002h5.69c-2.584-3.358-.053-6.487,2.694-6.487s5.277,3.133,2.7,6.487h17.194c-2.585-3.358-.052-6.487,2.694-6.487s5.277,3.133,2.7,6.487h4.345v2.222Zm6.817-4.943a1.558,1.558,0,1,0,1.567-1.558A1.565,1.565,0,0,0,5350.265,6999.282Zm22.586,0a1.567,1.567,0,0,0,3.134,0,1.567,1.567,0,0,0-3.134,0ZM5356.863,6998v-2.223h6.262v-16.888h-17.889v16.888h2.235V6998h-3.227c-.618,0-1.244-.331-1.244-.945v-19.137a1.357,1.357,0,0,1,1.244-1.252h20.146c.617,0,.969.64.969,1.252v19.137a.865.865,0,0,1-.969.945Zm23.254-.891v-5.762l-4.22-6.237h-6.513v12h-2.235v-13.242a1.113,1.113,0,0,1,1.229-.979c8.834,0,8.6-.148,8.985.417,5.459,7.913,4.988,7.053,4.988,7.7v6.106Zm-5.662-7.11h-2.835v-2.223h3.419c.813,0,.712.114,2.966,3.248l-1.835,1.321Z",
    transform: "translate(-5343.001 -6976.67)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.5980182b.svg";
export { ForwardRef as ReactComponent };